import { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ChartComponent from './ChartComponent';

const PackageSalesCharts = (props) => {
  const { parentProperties } = props || {};
  const { redux } = parentProperties || {};
  const { ipbPackageByChannel } = redux || {};
  const [noDataOrdersByProduct, setNoDataOrdersByProduct] = useState(false);
  const [logScale, setLogScale] = useState(false);
  const [dataType, setDataType] = useState([]);
  const [colors, setColors] = useState([]);
  const handleCheckboxChange = () => {
    setLogScale(!logScale);
  };
  const hslToHex = (h, s, l) => {
    s /= 100;
    l /= 100;
    const k = (n) => (n + h / 30) % 12;
    const a = s * Math.min(l, 1 - l);
    const f = (n) =>
      Math.round(255 * (l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)))));
    return `#${[f(0), f(8), f(4)].map((x) => x.toString(16).padStart(2, '0')).join('')}`;
  };
  const generateColors = (count) => {
    const baseColors = ['#906CD6'];
    const colors = [];
    for (let i = 0; i < count; i++) {
      if (i < baseColors.length) {
        colors.push(baseColors[i]);
      } else {
        const hue = ((i * 360) / count) % 360;
        const hex = hslToHex(hue, 70, 60);
        colors.push(hex);
      }
    }
    return colors;
  };
  const optionsType = {
    height: 500,
    colors: colors,
    legend: { position: 'top', maxLines: 3 },
    vAxis: { title: 'Cantidad', scaleType: logScale ? 'log' : undefined },
    isStacked: 'absolute',
    fontName: 'Inter-Light',
    italic: 'false',
    bold: 'false',
    with: '40px',
    fontSize: '15',
    background: 'none',
  };
  const [columnsProductTypes, setColumnsProductTypes] = useState([]);
  const [rowsProductType, setRowsProductType] = useState([]);
  useEffect(() => {
    generateDataColumnsProductTypes();
    return () => {};
  }, []);

  useEffect(() => {
    const rows = ipbPackageByChannel?.payload?.row || [];

    if (rows.length === 0) {
      setNoDataOrdersByProduct(true);
      return;
    }

    setNoDataOrdersByProduct(false);
    const chartData = processChartData(rows);
    const tableData = processTableData(rows);
    setDataType(chartData);
    setRowsProductType(tableData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ipbPackageByChannel]);

  const processChartData = (rows) => {
    const groupedByDate = {};

    rows.forEach(({ date, campaign, channel, quantity }) => {
      const key = `${campaign} - ${channel}`;
      if (!groupedByDate[date]) {
        groupedByDate[date] = {};
      }
      if (!groupedByDate[date][key]) {
        groupedByDate[date][key] = 0;
      }
      groupedByDate[date][key] += quantity;
    });

    // Obtener todas las combinaciones únicas de campaign - channel
    const allCombinations = Array.from(
      new Set(rows.map(({ campaign, channel }) => `${campaign} - ${channel}`)),
    );
    const chartData = [['Fecha', ...allCombinations, { role: 'annotation' }]];
    Object.entries(groupedByDate).forEach(([date, comboData]) => {
      const row = [date];
      allCombinations.forEach((combo) => {
        row.push(comboData[combo] || 0);
      });
      row.push(''); // annotation
      chartData.push(row);
    });
    const colors = generateColors(allCombinations.length);
    setColors(colors);
    return chartData;
  };

  const processTableData = (rows) => {
    return rows.map((item, index) => ({
      id: index,
      campaign: item.campaign,
      channel: item.channel,
      date: item.date,
      quantity: item.quantity,
    }));
  };

  const generateDataColumnsProductTypes = () => {
    const columns = [
      { field: 'date', headerName: 'Fecha', width: 150 },
      { field: 'quantity', headerName: 'Cantidad', width: 120 },
      { field: 'campaign', headerName: 'Campaña', width: 150 },
      { field: 'channel', headerName: 'Canal', width: 150 },
    ];
    setColumnsProductTypes(columns);
  };

  return (
    <Grid container spacing={5}>
      {ipbPackageByChannel.loaded === true && noDataOrdersByProduct === false ? (
        <Grid size={12}>
          <h3>
            Ventas de paquetes IPB por canal
            <span className='line'></span>
          </h3>
          <ChartComponent
            logScale={logScale}
            handleCheckboxChange={handleCheckboxChange}
            dataType={dataType}
            optionsType={optionsType}
            columnsProductTypes={columnsProductTypes}
            rowsProductType={rowsProductType}
          ></ChartComponent>
        </Grid>
      ) : noDataOrdersByProduct ? (
        <Grid size={12}>
          <h4>No hay datos para mostrar</h4>
        </Grid>
      ) : null}
    </Grid>
  );
};
export default PackageSalesCharts;
